import { render, staticRenderFns } from "./base-field-autocomplete.vue?vue&type=template&id=b976b4c6&"
import script from "./base-field-autocomplete.vue?vue&type=script&lang=js&"
export * from "./base-field-autocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports